import { render, staticRenderFns } from "./AddPage.vue?vue&type=template&id=af8df9fc&scoped=true&"
import script from "./AddPage.vue?vue&type=script&lang=js&"
export * from "./AddPage.vue?vue&type=script&lang=js&"
import style0 from "./AddPage.vue?vue&type=style&index=0&id=af8df9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8df9fc",
  null
  
)

export default component.exports